export const pencilDrawIcon = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3387 9.8197L14.776 8.2557L3.16667 19.8664V21.429H4.72933L16.3387 9.8197ZM5.83333 24.0957H0.5V18.7624L19.1667 0.0957031L24.5 5.42904L5.83333 24.0957ZM20.7293 5.42904L18.2227 7.93437L16.6627 6.3717L19.1667 3.86637L20.7293 5.42904Z"
    fill="var(--zbp-svg-primary-color, black)"
  />
</svg>
`;
